import React from "react";
import { Typography } from "@mui/material";

export const CustomMarkdownParagraph = ({ node, isSent = false, ...props }) => {
  return (
    <Typography
      variant="body1"
      component="p"
      fontSize={14}
      sx={{
        margin: "10px 0px",
        paddingTop: isSent ? 0 : "6px",
      }}
      {...props}
    />
  );
};
